module.exports = __webpack_public_path__ + "static/blinds-372ff26bb93ba4c5cbadb5a1fce31819.png";